import http from "../../rest/http";



export const validatePendingStaffService = async () => {
  try {
    const response = await http.get(`/api/v1/user/pending-active`);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};
